import { CommonRouter } from '@common';
import { routerPaths } from './tool';

import Home from '../home';
import LoginStudentID from '../component/login/loginStudentID';
import LoginSingPass from '../component/login/loginSingPass';
import Retrieve from '../component/retrieveStudentId/retrieve';
import EmailOTP from '../component/emailOTP';
import Retreieve from '../component/retreieve';
import { PrivacyStatement, TermsOfUse, FAQ } from '../../Common/components/footer';
function Router() {
    const routers = [
        {
            path: routerPaths.home,
            component: Home,
            exact: true,
        }, {
            path: routerPaths.login.loginStudentID,
            component: LoginStudentID,
            exact: true,
        }, {
            path: routerPaths.login.loginSingPass,
            component: LoginSingPass,
            exact: true,
        }, {
            path: routerPaths.emailOTP.index,
            component: EmailOTP,
            exact: true,
        }, {
            path: routerPaths.retrieve.index,
            component: Retreieve,
            exact: true,
        }, {
            path: routerPaths.retrieve.oprateStudentId,
            component: Retrieve,
            exact: true
        }, {
            path: routerPaths.privacyStatement,
            component: PrivacyStatement,
            exact: true,
        }, {
            path: routerPaths.termsOfUse,
            component: TermsOfUse,
            exact: true,
        },
        {
            path: routerPaths.FAQ,
            component: FAQ,
            exact: true,
        },
    ];

    return (
        <CommonRouter
            routers={routers}
        />
    );
}

export default Router;